import { Company } from './../index';

export class MinesiteCompanies {
    MinesiteId: number;
    Companies: Company[] = [];
}
